// import { sleepForMS, getEventSizeAsPercent, getPropSizes } from './../helpers/helpers';
// import { SelectAccountId, SetDocketLoadingStatus, JoiAccount } from '../store/accounts.era';
// import { UnloadEvent, StartEventsLoading, EventSuccess, AddManyEvents, ModifyEventEntity, RemoveEventEntity, LOAD_ALL_EVENTS_FLAG, LoadEvent, UnloadEvents, UpdateEvent, WFWorker, StartLoadingSingleEvent } from './../store/events.era';
// import { AppState, subTilDestroy, getOneStorePromise, getOneReselectorPromise } from './../store/store';
// import { AngularFirestoreCollection, AngularFirestore, DocumentChangeAction } from '@angular/fire/firestore';
import { inject, Injectable, Injector, OnDestroy, runInInjectionContext } from '@angular/core';
import { combineLatest, firstValueFrom, lastValueFrom, Subject, takeUntil } from 'rxjs';
import { ErrorStreamChange } from '../models/$error.model';
import { UserService } from './user.service';
import { UiService } from './ui.service';
import { LogService } from './log.service';
import { eventsActions, eventsFeature, JoiEvent, Snapshot } from '../store/events.era';
import { take } from "rxjs/internal/operators/take";
// import { ProgramService } from "./program.service";
import { tap, takeWhile, first } from 'rxjs';
// import { AccountsService } from "./accounts.service";
// import { Router } from "@angular/router";
import { environment } from "../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
// import { AddEventPreferences, EventPreferenceDoc, InitEventPreferences } from '../store/event.preferences.era';
import { select, Store } from '@ngrx/store';
import { User } from '../../../globals/store/user.data';
import { OnReset, Transitions } from './transition.service.helpers';
// import { validEventBearingAccountIds } from '../store/reselectors/accounts.reselector';
// import { EventPermissionsService } from './event.permissions.service';
// import { PermissionAccess, SetPageType } from '../store/permissions.era';
// import { routeIsSuspendedReselector } from '../store/reselectors/permissions.reselector';
// import { UpdateUiItem } from '../store/ui.data';
// import { PerformanceTrackingService } from './performance.tracking.service';
// import { traceNames } from './performance.tracking.data'
// import { SnapshotType, ProgramTimelineColumns, ProgramTimelinePerformerData, ProgramTimelineSnapshot, SnapshotPostData } from '../store/programs.data';
// import { FilterGroup } from '../store/filters.era';
// import { WorkerWithProfile } from '../store/workforce.data';
// import { SubscriptionHelper } from './helpers/subscriptions.helper';
 import { DecircularService } from './decircular.service';
 import { BaseJoiPage, cleanPages, combineEventAndPages, CreateEventData, Cue, CustomQuestion, EntityCall, JoiBaseEvent, JoiDataPage, JoiEventWithDeprecatedProps, LOAD_ALL_EVENTS_FLAG, MediaTerms, Ranking, SnapshotInfo, standardizeEvent, standardizeJoiPage, UpdateLabelsData } from '../../../globals/store/events.data';
// import { CreateEventData } from './../store/events.data';
// import { CoreEntityType } from '../store/share.data';
// import { eventListReselector } from '../store/reselectors/events.reselector';
// import { Entity } from '../store/entity.data';
import { Dictionary } from '@ngrx/entity';
import { userFeature } from '../store/user.era';
import { doc, FieldValue, collectionChanges, or, Firestore, QueryDocumentSnapshot, setDoc, Timestamp, query, collection, where, Query, DocumentData, DocumentChange, onSnapshot, updateDoc, WriteBatch, writeBatch, collectionData, QueryFieldFilterConstraint } from '@angular/fire/firestore';
import { EventPreferenceDoc, eventPreferencesActions } from '../store/event.preferences.era';
import { Router } from '@angular/router';
import { uiActions } from '../store/ui.era';
import { PermissionAccess, permissionsActions } from '../store/permissions.era';
import { EventPermissionsService } from './event.permissions.service';
import { getEventSizeAsPercent, sleepForMS, starLog, StoreWithDestroy, subTilDestroy } from '../helpers/helpers';
import { accountActions } from '../store/accounts.era';
import { AccountsService } from './accounts.service';
import { createId, jsonCopyObject } from 'globals/helpers/helpers';
import { Entity } from 'globals/store/entity.data';
import { CoreEntityType } from 'globals/store/share.data';
import { ProgramTimelineColumns, ProgramTimelinePerformerData, ProgramTimelineSnapshot, SnapshotPostData, SnapshotType } from 'globals/store/programs.data';
import { FilterGroup } from 'globals/store/filters.data';
import { WFWorker, WorkerWithProfile } from 'globals/store/workforce.data';
import { eventListReselector } from '../store/reselectors/events.reselector';
import { routeIsSuspendedReselector } from '../store/reselectors/permissions.reselector';
import { validEventBearingAccountIds } from '../store/reselectors/accounts.reselector';
import { SubscriptionHelper } from './helpers/subscriptions.helper';
import { JoiResource } from 'globals/store/resources.data';

@Injectable({ providedIn: 'root' })
export class EventService implements OnReset, OnDestroy, StoreWithDestroy {
  store = inject(Store);
  private db = inject(Firestore)

    readonly _file: string = 'event.service.ts'
    readonly api = `${environment.functionsURL}api/app`;

     get eventId():string { return this._eventId }
     private _eventId;
     private _accountId;
     private tempIgnoreDeleteEventIds = new Set()

     public recentlyAccepted = new Set() // necessary if you want the "View Event button on newly invited events (until next reload / full load).  Could also move to store, but this is a UI only thing, it seems okay
     public recentlyDeclined = new Set()

//     public traceName = traceNames;

    public eventInvitationLoadingSet: Set<string> = new Set()
    public processing = {};
     private suppress_removal_with_changed_account;
    private _prev_accountIds = [];
    private debug = true;
//    x = this.debug ? console.log : (m) => { };
    public snapshot_cache: Snapshot[] = [];

     public $destroy_events: Subject<boolean> = new Subject();
     public $destroy_selected_event: Subject<boolean> = new Subject();
     public event_queries_currently_loading = 0;
     public gotAccountEvents = false
     public _event: JoiEvent
     public _baseEvent: JoiBaseEvent
     public _eventPages: Dictionary<JoiDataPage> = {}
     private envInjector = inject(Injector)
     $destroy: Subject<boolean> = new Subject();

    ignoreDeletesForEventForMS(eventId: string, ms: number = 10000) {
      this.tempIgnoreDeleteEventIds.add(eventId)
      setTimeout(() => this.tempIgnoreDeleteEventIds.delete(eventId), ms)
    }

    softReset() {
      this.gotAccountEvents = false
      this.event_queries_currently_loading = 0
    }

    onReset(resetType, value = null) {
      switch (resetType) {
        case Transitions.OnExitUser:
          this._eventId = null; // to be safe, resetting both here
          this._eventPages = {}
          this._baseEvent = null
          this._accountId = null;
          this.recentlyAccepted.clear();
          this.recentlyDeclined.clear();
          this.$destroy_events.next(true);
          this.$destroy_selected_event.next(true) // might exit user from with event, right?
          this.softReset()
          // no break needed at the moment
        case Transitions.OnExitEvent:
          this._prev_accountIds = []
          this._eventPages = {}
          this._baseEvent = null
          this.$destroy_selected_event.next(true)
          break
        default:
          break;
      }
    }

     constructor(
         public http: HttpClient,
         private ui: UiService,
         private log: LogService,
         private userService: UserService,
         public accountService: AccountsService,
         public router: Router,
         private permissionsService: EventPermissionsService,
//         private perf: PerformanceTrackingService,
         private subscriptionHelper: SubscriptionHelper,
//         private programService: ProgramService,
         private decircularService: DecircularService,
     ) {
      // setInterval(() => console.log(this.event_queries_currently_loading), 1000)
      // starLog("Event service starting...")

       subTilDestroy(this, select(eventsFeature.selectEvent), '_event')
      combineLatest([this.store.pipe(select('user','user','uid')),
        this.store.pipe(select('events','eventId'))]
      ).subscribe(([uid, eventId])=>{
        console.log({eventId, uid})
        if(!eventId || !uid) return
        if(eventId === LOAD_ALL_EVENTS_FLAG && this._eventId !== null) { 
          this._eventId = null;
          this.store.dispatch(eventsActions.unloadEvent())
        }
        if (eventId && eventId !== LOAD_ALL_EVENTS_FLAG && eventId !== this._eventId) {
          this.getSelectedEvent(eventId) // TODO: see if this is being called in duplicate before dup is complete which leads to it being manually deleted and sending the log and error
          this.store.dispatch(eventsActions.startLoadingSingleEvent())
          this.unloadHomeConnectionsToEvents()
        }
      })


      this.store.select(routeIsSuspendedReselector).subscribe(routeToNavigateTo => {
        // console.log({ routeToNavigateTo, path: this.router.url, router: this.router })
        if (routeToNavigateTo && this.router.url !== '/tasks') {
          this.router.navigate(routeToNavigateTo)
        }

       }) // this could be a major source of bugs.  CAREFUL

      // account loading is triggered when all accounts are loaded (this is no longer the case)
      this.store.pipe(select(validEventBearingAccountIds)).subscribe(({ ids, accountsLoading })=>{
        // console.log({ accountsLoading, prevAccountIds: jsonCopyObject(this._prev_accountIds), ids: jsonCopyObject(ids) })
        if(!this._eventId && ((!accountsLoading && this._prev_accountIds.length !== ids.length) ||
        (!accountsLoading && !this.gotAccountEvents && !this._eventId))) { // changing !accountsLoading || to !accountsLoading && is OK (and necessary to prevent unnecessary calls to getAccountEvents) because the validEventBearingAccountIds reselector will fire when accountsLoading switches back to false // still need to handle the case where there are no accounts after loading but there are invitations.  Just not every single time
          // const newIds = listDifference(ids, this._prev_accountIds)
          // console.log({ newIds })
          const less_ids = ids.length < this._prev_accountIds.length;
          this._prev_accountIds = ids;
          this.getAccountEvents(ids, less_ids);
        }
      })

   // Feel free to not keep this if there is a better solution for internal
      this.store.pipe(select('accounts','suspended')).subscribe(suspended=>{
        this.store.pipe(select('events','event'),take(1)).subscribe((event:JoiEvent) => {
          if(!event) return;
          // console.log('suspended , event ',suspended, event)
          this.store.dispatch(eventsActions.updateEvent({is_suspended: suspended && suspended[event.accountId] }))
        })
      })
     }

  async getEventFromOutsideEvent(eventId) {
    this.$destroy_selected_event.next(true)
    await this.getSelectedEvent(eventId)
  }

  async openingEvent(clickEvent, event: JoiEvent, account_is_supended:boolean = false) { // open event with [routerLink]

    if (account_is_supended) {
      console.log("Exiting opening event")
      return // event was loaded in all tasks or somewhere - easier to fix here by not loading again than elsewhere
    }

    let goToTimeline: boolean
    const user: User = await firstValueFrom(this.store.pipe(select(userFeature.selectUser), take(1)))
    if (event.users.includes(user.uid)) {
      const access = await this.permissionsService.getRestrictionsFor(user.uid, event.eventId)
      goToTimeline = !access.types.some(t => !['performer', 'facilitator', 'crew'].includes(t))
    }
    
    // link like behavior
    const path = `event/${goToTimeline ? 'timeline' : 'build'}/${event.eventId}`
    if (clickEvent?.shiftKey) { // new browsing context - can't force new window without breaking good coding standards, see https://stackoverflow.com/questions/12939928/make-a-link-open-a-new-window-not-tab
      window.open(path, '_blank')
      return
    } else if (clickEvent?.ctrlKey) { // new tab
      window.open(path)
      return
    } else if (clickEvent?.metaKey) {
      window.open(path, '_blank')
      return
    }
    
    // this.perf.start('View Event', true)
    this.store.dispatch(permissionsActions.setPageType(goToTimeline ? 'my_schedule' : 'program'))
    this.router.navigate([path])
    // await sleepForMS(50)
    // this.perf.stop('View Event')
  }



  sendEventToStore() {
    if (!this._baseEvent) return
    this._baseEvent = { ...this._baseEvent }
    const event = jsonCopyObject(combineEventAndPages(this._baseEvent, Object.values(this._eventPages) || []))
    standardizeEvent(event)
    console.log({event})
    this.store.dispatch(eventsActions.loadEvent(event))
  }

  // async loadResourcesForEvents(eventIds: string[]): Promise<JoiResource[]> {
  //   if (!eventIds?.length) return []
  //   const resources: JoiResource[] = []
  //   for (const eventId of eventIds) {
  //     const eventQuery = runInInjectionContext(this.envInjector, () => query(collection(this.db, 'eventPages'), where('eventId', 'in', eventIds)))
  //     const eventSnapshot = await firstValueFrom(runInInjectionContext(this.envInjector, () => collectionChanges(eventQuery).pipe(take(1))))
  //     const event = eventSnapshot[0]?.doc.data()
  //     if (event) {
  //       resources.push(...Object.values(event.resources) as JoiResource[])
  //     }
  //   }
  //   return resources
  // }

  async getSelectedEvent(eventId): Promise<boolean> {

    return new Promise((resolve, reject) => {
      let loaded = false
      this._eventId = eventId
      console.log("Get selected event", { eventId })
      const eventPagesQuery = runInInjectionContext(this.envInjector, () => query(collection(this.db, 'eventPages'), where('eventId', '==', eventId)))
      runInInjectionContext(this.envInjector, () => collectionChanges(eventPagesQuery).pipe(tap(() => {}),takeUntil(this.$destroy_selected_event)).subscribe({next:(changes:DocumentChange<JoiDataPage>[])=>{
          const pages = changes.filter(c => c.type !== 'removed').map(c => c.doc.data())
          pages.forEach(p => this._eventPages[p.id] = p)
          changes.filter(c => c.type === 'removed').forEach(c => delete this._eventPages[c.doc.data().id]) // should only happen when restoring from backup
          console.log({ eventPages: this._eventPages })
          this.sendEventToStore()
        },
          error:  response=>{
          let message = 'There was an error loading the pages for this event'
          console.log("ERROR DOWN HERE", { response })
          this.log.error({file:this._file, function:'getSelectedEvent pages error', response, message,error:new Error()})
        }})
      )
      
      const eventQuery = runInInjectionContext(this.envInjector, () => query(collection(this.db, 'events'), where('eventId', '==', eventId)))
      runInInjectionContext(this.envInjector, () => collectionChanges(eventQuery).pipe(
        tap({ next:
          (changes:DocumentChange<JoiBaseEvent>[])=>{
            console.log({changes})
            if(!changes.length){
              this.manuallyRemoveCurrentEvent()
              this.log.error({file:this._file, function:'getSelectedEvent !changes.length',message:'This event has been deleted',error:new Error(), data: {eventId}})
              return 
            }
            const event = changes[0].doc.data()
            event.percentUsed = getEventSizeAsPercent(event)
            if (this._accountId !==  event.accountId) {
              this.store.dispatch(accountActions.selectAccountId(event.accountId));
              this._accountId = event.accountId;
            }
            try {
              this.initializeEvent(event, this.userService.uid)    
            } catch(error) {
              console.log("There was an error in eventService.initializeEvent", { error })
              return
            }
            console.log({ baseEvent: event })
            this._baseEvent = event
            this.sendEventToStore()
            if (!loaded) resolve(true)
            loaded = true
          },
          error: (response)=>{
            console.log("ERROR IN HERE", { response })
            this.log.error({file:this._file, function:'getSelectedEvent',response,error:new Error()})
            resolve(false)
          }}
        ),
        takeUntil(this.$destroy_selected_event)
      ).subscribe({error:
          response=>{
            let message = 'There was an error loading this event'
            if(response.code === 'permission-denied') {
              message = 'Your access to this event has been removed'
              this.manuallyRemoveCurrentEvent()
            }
            console.log("ERROR DOWN HERE", { response })
            this.log.error({file:this._file, function:'getSelectedEvent error', response, message,error:new Error()})
          }}
      ));
      this.getEventPreferences()
    })
    
  }

  async deleteFromEventPages(type: keyof BaseJoiPage, ids: string[]) {
    await this.decircularService.deleteFromEventPages(type, ids, Object.values(this._eventPages) || [])
  }

  async saveEventPageEntities(type: keyof BaseJoiPage, entities: Entity[]) {
    if (!this._event) throw new Error("Missing event to save entities on!")
console.log({type, entities, pages: this._eventPages})
    const { eventId, accountId } = this._event
    await this.decircularService.saveEventPageEntities(type, entities, eventId, accountId, Object.values(this._eventPages) || [])
  }
  

  getAccountEvents(ids: (string| number)[], removed_ids:Boolean){
    this.gotAccountEvents = true
    this.$destroy_selected_event.next(true); // to be safe. HOWEVER, DO NOT TRIGGER destroy_events here, as it is possible this method is called multiple times upon loading the dashboard (and it is called at least twice every time you exit an event, after subscriptions have timed out)

    this._eventId = null;
    this._accountId = null;
    
    // console.log({ removed_ids});
    if(removed_ids) this.store.dispatch(eventsActions.startEventsLoading()) // this unloads the single event too
    
    const firestoreEventsOrQueries: QueryFieldFilterConstraint[] = [];
    this.event_queries_currently_loading++; // = ids.length

    firestoreEventsOrQueries.push(where('accountId', 'in', ids.filter(id => !!id))) // in queries don't work with undefined or null, so filter those out.  This should be fine because if the id is undefined or null, it means there is no account, and therefore no events to load for that account, so it shouldn't cause any events to not load that should be loading.  Still seems a little risky though, need to keep an eye on this and make sure there aren't any weird edge cases where an event with a null or undefined accountId could exist and should be loading but isn't because of this
    firestoreEventsOrQueries.push(where('users', 'array-contains', this.userService.uid))
    const q = query(collection(this.db, 'events'), or(...firestoreEventsOrQueries))
    this.subscriptionHelper.subscribeToCollectionsWithHandlerAndStopper(q, 'events', this.handleEventChangesFromDB.bind(this), this.$destroy_events, this._file, 'getAccountEvents')

  }

  getEventPreferences(){
    this.store.dispatch(eventPreferencesActions.initEventPreferences())
    runInInjectionContext(this.envInjector, () => onSnapshot(doc(this.db, 'events/'+ this._eventId + '/preferences/' + this.userService.uid), { next:(changes)=>{
        if(!changes.exists) this.store.dispatch(eventPreferencesActions.initEventPreferences(false))
        // switch(changes){
        //   case 'value':
        console.log({changes, data: changes.data()})
            if(changes.data()) this.store.dispatch(eventPreferencesActions.addEventPreferences(changes.data() as EventPreferenceDoc))
        //     break;
        // }
      }, error:
      response=>this.log.error({file:this._file, function:'getEventPreferences',response,error:new Error()})
    })
    );
  }


  initializeEventFromChangeAction(changeAction: DocumentChange<JoiEvent>, uid:string): JoiEvent { // <== this is only called by multiple events (outside event), so standardize event is called in here instead of in the send event to store
    const initializedEvent = changeAction.doc.data() as JoiEvent;
    initializedEvent.eventId = changeAction.doc['id'] // cheaply ensure that the id and DB id are always in sync
    standardizeEvent(initializedEvent) // both events from outside and inside an event need to be standardized
    this.initializeEvent(initializedEvent, uid)
    return initializedEvent  
  }

  initializeEvent(event:JoiEvent, uid:string) { // mutates in place
    event.is_suspended = !this.accountService.suspendedAccounts ? false : this.accountService.suspendedAccounts[event.accountId]
    if(event.invitation && event.invitation.length){
      const invited_data = event.invitation
        .filter(inv => inv.receiver === uid && inv.status === 'pending')
        .map(inv => ({sender:inv.sender}))
      if(invited_data.length > 0 && event.workforce){
        event.is_invited = true;
        event.invite_sender = event.workforce.find(user=>invited_data[0].sender === user.uid);
      }
    }
    event.can_access = event.users.includes(uid)
    // I'm NOT returning the event to make clear that this mutates in place.  This should not pretend to do something it doesn't, which is create a copy of the event and return it (which is what returning the event means)
  }

  manuallyRemoveCurrentEvent() {
    this.$destroy_selected_event.next(true)
    this.store.dispatch(eventsActions.removeEventEntity(this._eventId));
    this._eventId = null
    this.store.dispatch(eventsActions.unloadEvent())
    this.router.navigate(['home'])
    console.log('Event was deleted while viewing it, should be navigating to the dashboard...')
  }

  async addCue(cue: Ranking) {
    const event = await this.getCurrentEvent()
    event.cues.push(cue)
    await this.updateEvent(event.eventId, { cues: event.cues })
  }

  async updateCueName(id: string, name: string) {
    const event = await this.getCurrentEvent()
    event.cues.find(c => c.id === id).name = name
    await this.updateEvent(event.eventId, { cues: event.cues })
  }

  async updateCues(cues: Ranking[]) {
    const event = await this.getCurrentEvent()
    await this.updateEvent(event.eventId, { cues })
  }

  async updatePerformerRoles(performerRoles: Ranking[]) {
    const event = await this.getCurrentEvent()
    await this.updateEvent(event.eventId, { performerRoles })
  }

  handleEventChangesFromDB(changes:DocumentChange<JoiEvent>[]){
    // console.log('event service event changes ', changes);
    changes.forEach(change =>{
       const changeDoc = change.doc
       const c = changeDoc.data();
       console.log({ changeDoc, c })
    })
    console.log({ changes, nChanges: changes.length })
    if(this.event_queries_currently_loading > 0) this.event_queries_currently_loading--;
    const removed_ids = [];
    if(changes.length === 0){
      this.store.dispatch(eventsActions.eventSuccess())
    }

    const eventsToAdd: JoiEvent[] = changes.filter(c=> c.type === 'added').map(change=>this.initializeEventFromChangeAction(change, this.userService.uid))

    if (eventsToAdd.length) {
      console.log({ eventsToAdd: jsonCopyObject(eventsToAdd) })
      this.store.dispatch(eventsActions.addManyEvents( eventsToAdd ))
    }

    changes.filter(c=> c.type !== 'added').forEach(change => {
      switch(change.type){
        case 'modified':
          const event = this.initializeEventFromChangeAction(change, this.userService.uid)
          this.store.dispatch(eventsActions.modifyEventEntity(change.doc['id'], event))
          break;
        case 'removed':
          const eventId = change.doc['id']
          console.log({ eventId, tempIgnore: this.tempIgnoreDeleteEventIds, suppress: this.suppress_removal_with_changed_account })
          if(this.recentlyAccepted.has(eventId)) this.recentlyAccepted.delete(eventId);
          if (this.tempIgnoreDeleteEventIds.has(eventId)) return
          if(!this.suppress_removal_with_changed_account || this.suppress_removal_with_changed_account !== eventId){
            if (this._eventId === eventId) { // I am assuming that this means the user is looking at the event
                this.manuallyRemoveCurrentEvent()
            } else {
                this.store.dispatch(eventsActions.removeEventEntity(eventId));
            }
            removed_ids.push(eventId)
          }else{
            this.suppress_removal_with_changed_account = null;
          }
          break;
      }
    })
    // console.log('this.event_queries_currently_loading ', this.event_queries_currently_loading);
    if(this.event_queries_currently_loading === 0){
      this.store.dispatch(eventsActions.eventSuccess())
      this.store.pipe(select('events','entities'), take(1)).subscribe((entities: { [key: string]: JoiEvent })=>{
        const valid_entities: JoiEvent[] = Object.values(entities).filter(ev=>!removed_ids.includes(ev.eventId))
        if(valid_entities.length === 0) return
        this.accountService.setWorkforceAccounts(valid_entities)
      })
    }
  }
  // set timeout to unsubscribe to all connections unless is selected_event, or is all with no selected_event
  unloadHomeConnectionsToEvents(){
    this.store.dispatch(accountActions.setDocketLoadingStatus(true)) // needs to be set to true so that the proper page is shown (or rather, the wrong page is not shown) before loading a new docket
    this.$destroy_events.next(true)
    // console.log("DB Connection timed out, destroying events")
    this.store.dispatch(eventsActions.unloadEvents())
    this._prev_accountIds = []
    this.softReset()
  }

  updateEvent(eventId:string, changes:Partial<JoiEventWithDeprecatedProps>, log_data:Partial<ErrorStreamChange> = {}) {
    return this.decircularService.updateEvent(eventId, changes, log_data)
  }

  async deleteTerms(terms: MediaTerms, type: CoreEntityType) {
    const { mediaTerms, eventId } = await this.getCurrentEvent()
    mediaTerms[type] = mediaTerms[type].filter(t => t.id !== terms.id)
    this.updateEvent(eventId, { mediaTerms })
  }

  async updateTerms(terms: MediaTerms, type: CoreEntityType) {
    const { mediaTerms, eventId } = await this.getCurrentEvent()
    const termsList = mediaTerms[type]
    termsList[termsList.findIndex(t => t.id === terms.id)] = terms
    this.updateEvent(eventId, { mediaTerms })
  }

  async updateEntitySubmitters(submitTemplates: EntityCall[], type: CoreEntityType) {
    const { submitters, eventId } = await this.getCurrentEvent()
    submitters[type] = submitTemplates
    this.updateEvent(eventId, { submitters })
  }

  async setProgramName(programId: string, programName: string) {
    const event = await this.getCurrentEvent()
    console.log("Set program name called!", { programId, programName })
    event.programNames[programId] = programName
    this.updateEvent(event.eventId, { programNames: event.programNames })
  }


  async updateEventLabels(data: UpdateLabelsData) {
    const url = `${this.api}/update-event-labels`
    await this.http.post(url, data).toPromise()
  }

  createEventPreferences(document: EventPreferenceDoc, eventId:string, uid:string, log_data:Partial<ErrorStreamChange> = {}):Promise<void> {
    document.updatedAt = new Date()
    return setDoc(doc(this.db, `events/${eventId}/preferences/${uid}`), document, {merge:true}).catch(response => {
      this.log.error({
          response,
          data: { document, eventId, uid},
          error: new Error,
          message: 'There was an error creating your preferences',
          ...log_data
      });
    })
  }
  updateEventPreferences(document:Partial<EventPreferenceDoc>, eventId:string, uid:string, log_data:Partial<ErrorStreamChange> = {}){
    // const ref = this.afs.doc<EventPreferenceDoc>(`events/${eventId}/preferences/${uid}`)
    document.updatedAt = new Date()
    return updateDoc(doc(this.db, `events/${eventId}/preferences/${uid}`), document).catch(response => {
      this.log.error({
          response,
          data:{ document, eventId, uid },
          error: new Error,
          message: 'There was an error updating your preferences',
          ...log_data
      });
    })
  }

  async updateCustomQuestions(questions: CustomQuestion[], type: CoreEntityType) {
    const event = await this.getCurrentEvent()
    switch (type) {
      case 'attendee':
        this.updateEvent(event.eventId, { attendeeQuestions: questions })
        break
      case 'performer':
        this.updateEvent(event.eventId, { performerQuestions: questions })
        break
      case 'resource':
        this.updateEvent(event.eventId, { resourceQuestions: questions })
        break
      case 'exhibitor':
        this.updateEvent(event.eventId, { exhibitorQuestions: questions })
        break
      default:
        console.log("No handling for custom questions", type, questions)
        return
    }
  }

  async addCustomQuestion(data: CustomQuestion, type: CoreEntityType) {
    const event = await this.getCurrentEvent()
    switch (type) {
      case 'attendee':
        this.updateEvent(event.eventId, { attendeeQuestions: [...event.attendeeQuestions, data] })
        break
      case 'performer':
        this.updateEvent(event.eventId, { performerQuestions: [...event.performerQuestions, data] })
        break
      case 'resource':
        this.updateEvent(event.eventId, { resourceQuestions: [...event.resourceQuestions, data] })
        break
      case 'exhibitor':
        this.updateEvent(event.eventId, { exhibitorQuestions: [...event.exhibitorQuestions, data] })
        break
      default:
        console.log("No handling for custom question", type, data)
        return
    }
  }


  async createEvent(data: CreateEventData): Promise<string> {
    const user = await lastValueFrom(this.store.select(userFeature.selectUser).pipe(take(1))) as User
    if (!user) { // just making sure, before an event was created with no user
      console.log("missing a user to create an event with")
      throw new Error("No user present in store for createEvent")
    }
    const url = `${this.api}/create-event`

    const response = await lastValueFrom(this.http.post(url, data).pipe(take(1))) as JoiEvent
      console.log({ response })
    if (!response.eventId) throw new Error("Event not returned")
    
    return response.eventId
  }

  async copyTitle(title) { // check for previous copies and adjust titles - if first copy, just add copy of to the front
    const titleRegex = /^Copy (of|\d+) /
    const titleBase = title.replace(titleRegex, '')
    const eventList = await lastValueFrom(this.store.select(eventListReselector).pipe(take(1)));
    const siblingRanks = eventList.filter(e => e.title.replace(titleRegex, '') === titleBase)
                                  .filter(e => !!e.title.match(titleRegex)) // make sure it actually has the regex inside and not just the titleBase
                                  .map(e => e.title.match(titleRegex)[1]) // second element is "of" or number, otherwise match would be null above 
                                  .map(numberText => numberText === 'of' ? 1 : parseInt(numberText, 10))
    return siblingRanks.length === 0 ? `Copy of ${title}` : `Copy ${Math.max(...siblingRanks) + 1} ${titleBase}`
  }

    async grantWorkforcePrivileges(event: JoiEvent) {
      // this.perf.start(traceNames.actionWorkforce)
      const args = arguments;
      const user = await firstValueFrom(this.store.select(userFeature.selectUser).pipe(take(1)))
      if(!user){
        console.log("missing a user to grantWorkforcePrivileges to")
        return new Error("No user present in store for grantWorkforcePrivileges")
      }
      const event_update = {
        workforce: [...event.workforce.filter(wf => wf.email !== user.email), {
            'email': user.email || '',
            'firstName': user.firstName || '',
            'lastName': user.lastName || '',
            'photoURL': user.photoURL || '',
            'uid': user.uid,
            'status': 'accepted'
        }],
        users: [...event.users.filter(u=>u!==user.uid), user.uid],
        invitation: [...event.invitation, {
          date_sent: new Date(),
          sender: user.uid,
          receiver: user.uid,
          status: 'accepted'
        }]
      }
      const url = `${this.api}/admin-granted-wf-privileges`;
      try {
        const grantPrivileges = await lastValueFrom(this.http.post(url, { eventId: event.eventId, uid: user.uid }).pipe(take(1)))
        return true;
      } catch (e) {
        this.log.error({
            function: "grantWorkforcePrivileges",
            error: new Error(), file: this._file, args, message: 'There was an error while adding you into the workforce', response: e,
        });
      }
      this.log.error({
          file:this._file, response: null,
          error: new Error(), function: 'grantWorkforcePrivileges() /admin-granted-wf-privileges',
          data: { event, uid: user.uid }, message: 'Error granting full privileges to this event'
      } as ErrorStreamChange)
    }

    async duplicateEvent(event: JoiEvent, eventName:string, accountId:string, new_date){
      let date_diff;
      if(new_date){
        const old_date = new Date(event.dates[0]);
        if(old_date && old_date !== new_date){
          date_diff = new_date.getTime() - old_date.getTime() + (2 * 60 * 60 * 1000); // two hours more to account for daylight savings time
        }
      }
      try {
        const url = `${this.api}/duplicate-event`
        const data: CreateEventData = {
          accountId,
          eventName,
          sourceEventId: event.eventId,
          date_diff
        }
        const response = await this.http.post(url, data).toPromise() as { eventId: string }
        console.log({ response })
        return response.eventId
      } catch (response) {
        const message = response.error && response.error === 'User has no permissions to duplicate this event' ? response.error : 'Error duplicating event';
        this.log.error({file:this._file, error: new Error(response.error || ""), response, function:'duplicateEvent',message, data:{event, eventName, accountId, new_date}})
        this.store.dispatch(uiActions.updateUIItem('takeover_loading', null))
      }
    }



    changeEventAccount(eventId, accountId){
      this.ignoreDeletesForEventForMS(eventId, 20000)
      const url = `${this.api}/change-event-account`;
      this.http.post(url, { eventId, accountId })
        .pipe(take(1))
        .subscribe(changeEventAcccountReturnData =>{
          console.log({ changeEventAcccountReturnData })
        }, response=>{
          this.suppress_removal_with_changed_account = null;
          this.log.error({file:this._file, function:'changeEventAccount()', response, data:{eventId, accountId}, message:'There was an error switching the event\'s account'})
        })
    }


    deleteEvent(eventId) {
        // delete stats and account tally update done in onDelete functions using node
        const q = query(collection(this.db, 'events'), where('eventId', '==', eventId))
        const batch: WriteBatch = writeBatch(this.db);
        collectionData(q, { idField: 'docId' }).pipe(take(1)).subscribe({
          next: (events) => {
            events.forEach(event => {
              batch.delete(doc(this.db, 'events', event.docId))
            })
            batch.commit().then(()=>{
              console.log("Event deletion batch committed successfully")
            }).catch(error=>{
              console.log("Error committing event deletion batch", { error })
              this.log.error({ file: this._file, function: 'deleteEvent batch commit', error: new Error(), response: error, data:{ eventId }, message: 'Error deleting event' })
            })
          }, error: (response)=>{
            console.log("Error getting event for deletion", { response })
            this.log.error({ file: this._file, function: 'deleteEvent get event', error: new Error(), response, data:{ eventId }, message: 'Error deleting event' })
          }
        })
        // I'm not sure why, but this action, delete event, only comes back with the deleted information (and hence updates the event entities) for other users, so we need to dispatch this deletion manually here:
        if (this._eventId === eventId) { // I am assuming that this means the user is looking at the event
          this.manuallyRemoveCurrentEvent()
        }
        console.log("Removing event from store...", eventId)
        this.store.dispatch(eventsActions.removeEventEntity(eventId)) // this needs to be done no matter what because there could be an _eventId on the dashboard
    }

    async closeEvent(event: JoiEvent) {
      const user = await firstValueFrom(this.store.select(userFeature.selectUser).pipe(take(1)))
        event.closed = true;
        event.closedBy = user.uid;
        event.closedAt = Timestamp; // this.helper.timestamp;
        const url = `${this.api}/close-event`;
        this.ignoreDeletesForEventForMS(event.eventId)
        return new Promise((resolve, reject) => {
            this.http.post(url, { eventId: event.eventId, accountId: event.accountId, cancelled: false }).pipe(take(1)).subscribe(() => {
                console.log('close event complete')
                resolve(true);
            }, (response) => {
                const message = 'Close error: This event did not close properly.'
                this.log.error({
                    file: this._file,
                    error: new Error(), function: 'closeEvent', data: { event }, message, response, code: 'event-update'
                });
                reject(message)
            })
        })
    }

    accept(event: JoiEvent, $event?: MouseEvent) {
        if ($event) $event.stopPropagation();
        this.recentlyAccepted.add(event.eventId)
        console.log({ recentlyAccepted: this.recentlyAccepted })
        this.eventInvitationLoadingSet.add(event.eventId);
        this.sendReply(event, 'accepted');
    }
    decline(event: JoiEvent, $event?: MouseEvent) {
        if ($event) $event.stopPropagation();
        this.eventInvitationLoadingSet.add(event.eventId);
        this.recentlyDeclined.add(event.eventId)
        this.sendReply(event, 'declined');
        // check if this is the only event that requires its account => accountIds was not being set in accounts.service and so commenting this out for now
/*         if (!this.accountService.accountIds.includes(event.accountId)){ 
          this.store.dispatch(new RemoveAccountPublicInfo(event.accountId))
        } */
    }
    sendReply(event: JoiEvent, reply: 'accepted' | 'declined') {
        this.processing[event.eventId] = true;
        const url = `${this.api}/invite-workforce-reply`;
        this.http.post(url, { eventId: event.eventId, reply })
            .pipe(take(1))
            .subscribe(() => {
                this.eventInvitationLoadingSet.delete(event.eventId)
                setTimeout(_ => { this.processing[event.eventId] = false }, 1000 * 4)
            }, (response) => {
                this.eventInvitationLoadingSet.delete(event.eventId)
                this.log.error({
                    file: 'event.service',
                    error: new Error(), function: 'sendReply ' + reply, data: { event, eventId: event.eventId }, message: 'Error saving response'
                } as ErrorStreamChange)
                this.processing[event.eventId] = false;
            })
    }

    updateTitle(event: JoiEvent, new_title) {
        return this.updateEvent(event.eventId, { title: new_title });
    }

    getSnapshotInfo(name: string) {
      return { id: createId(), name, timestamp: Date.now() / 1000 }
    }

    async saveSnapshot(columns: ProgramTimelineColumns, timelineFilters: FilterGroup, tempTimelineFilterCount: number, currentEvent: JoiEvent, workersByEmail: { [key: string]: WorkerWithProfile }, performerData: ProgramTimelinePerformerData) {
        let name;
        if (!currentEvent.snapshots) {
            name = 'Snapshot 1';
            currentEvent.snapshots = [];
        } else {
            name = 'Snapshot ' + (currentEvent.snapshots.length + 1);
        }
        const shot = this.getSnapshotInfo(name)
        const template = {
            program: currentEvent.program_labels || this.ui.defaultLabels,
            session: currentEvent.session_labels || this.ui.defaultLabels,
            workersByEmail
        };
        const snapshots = currentEvent.snapshots ? [...currentEvent.snapshots, shot] : [shot];
        const snapshot: ProgramTimelineSnapshot = { columns, template, timelineFilters, tempTimelineFilterCount, performerData }
        const result = await this.uploadSnapshot(shot, snapshot)

        console.log({ result, snapshot })
        this.updateEvent(currentEvent.eventId, { snapshots })
    }

    async uploadSnapshot<S>(snapshotInfo: SnapshotInfo, snapshot: S) { // uses the same function for program snapshots as well as others (budget)
      const snapshotPostData: SnapshotPostData<S> = { eventId: (await this.getCurrentEvent()).eventId, shotId: snapshotInfo.id, snapshot }
      return await this.http.post(`${this.api}/upload-snapshot`, snapshotPostData).toPromise()
    }

    async uploadBudgetSnapshot<S>(snapshotInfo: SnapshotInfo, snapshot: S, type: SnapshotType = 'revenue') { // uses the same function for multiple budget snapshot types
      const snapshotPostData: SnapshotPostData<S> = { eventId: (await this.getCurrentEvent()).eventId, shotId: snapshotInfo.id, snapshot, type }
      console.log({ snapshotPostData })

      return await this.http.post(`${this.api}/upload-budget-snapshot`, snapshotPostData).toPromise()
    }

    async getCurrentEvent(): Promise<JoiEvent> {
      const event = await lastValueFrom(this.store.pipe(select(eventsFeature.selectEvent), first()));
      if(event && event.eventId) {
        return jsonCopyObject(event);
      }
      throw new Error("No current event loaded!")
    }

    async changeEventOwner(event: JoiEvent, newOwner: WFWorker) {

      const oldOwnerWorkerObject = event.workforce.find(w => w.uid === event.owner_uid)
      oldOwnerWorkerObject.role = oldOwnerWorkerObject.role === 'Event Owner' ? '' : oldOwnerWorkerObject.role || ''

      const widePermissions: PermissionAccess = { types: ['program'] }

      
      await this.permissionsService.saveRestrictionsFor(newOwner.uid, widePermissions)
      const changeEventOwnerData = { owner_uid: newOwner.uid, eventId: event.eventId }
      console.log({ changeEventOwnerData })
      
      await this.http.post(`${this.api}/change-event-owner`, changeEventOwnerData).toPromise()
      /* const changes: Partial<JoiEvent> = { event_owner: newOwnerWorkerObject, owner_uid: newOwner.uid, workforce: event.workforce }
      // console.log({ changes })
      this.updateEvent(event.eventId, changes) */

    }

  async preloadEvent(eventId: string): Promise<JoiEvent> {
    if (this.eventId !== eventId) {
      // console.log({ eventId, event: this._event, thisEventId: this.eventId })
      await this.getEventFromOutsideEvent(eventId)
      // await this.programService.getProgramsFromOutsideEvent(eventId)
    }
    while (!this._event || this._event.eventId !== eventId) {
      console.log("Loading event...")
      await sleepForMS(50)
    }
    
    return this._event
  }

  ngOnDestroy() {
    this.$destroy.next(true); this.$destroy.complete();
  }
}
